import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowonDeviceComponent } from '../showon-device.component/showon-device.component'


@NgModule({
  declarations: [ShowonDeviceComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [ShowonDeviceComponent]
})
export class ShowonDeviceModule { }
